if (!customElements.get('atelier-product-editorial')) {
  customElements.define('atelier-product-editorial', class extends HTMLElement {
    connectedCallback() {
      this.onClick = (event) => {
        const link = event.target.closest('[data-product-media-id]');
        if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        const trigger = document.querySelector(`product-info[id^="MainProduct-"] .product__media-toggle[data-media-id="${CSS.escape(link.dataset.productMediaId)}"]`);
        if (trigger) {
          event.preventDefault();
          trigger.click();
        }
      };
      this.addEventListener('click', this.onClick);
    }
    disconnectedCallback() { this.removeEventListener('click', this.onClick); }
  });
}
